import { Plan, PlanFormData } from "../types";

export function buildFormData(data?: Plan): PlanFormData {
  return {
    id: data?.id || "",
    applicationId: data?.applicationId || "",
    name: data?.name || "",
    type: data?.type || "public",
    credits: data?.credits || 0,
    price: Number(data?.price || 0),
    pricePerOverageCredit: Number(data?.pricePerOverageCredit || 0),
    chargeIncomingMessages: JSON.stringify(
      typeof data?.chargeIncomingMessages === "boolean" ? data.chargeIncomingMessages : true
    ),
    period: data?.period || "day",
    duration: data?.duration || 0,
  };
}
